<web-design-system-button (click)="start()" type="secondary" size="small">
  {{ 'user-self-service.terminate-depot.button' | transloco }}
</web-design-system-button>

<ng-template #modal let-modal>
  @switch (currentStep) {
    @case (Step.HINT) {
      <web-design-system-modal [headline]="'user-self-service.terminate-depot.hint.headline' | transloco" (dismiss)="close()">
        <p [innerHTML]="'user-self-service.terminate-depot.hint.body' | transloco"></p>
        <div class="d-flex align-items-center justify-content-between mt-4">
          <div>
            <a class="link-secondary text-uppercase cursor-pointer" (click)="next()">
              {{ 'user-self-service.terminate-depot.hint.next' | transloco }}
            </a>
          </div>
          <div class="spacer"></div>
          <web-design-system-button (click)="close()">
            {{ 'user-self-service.terminate-depot.hint.close' | transloco }}
          </web-design-system-button>
        </div>
      </web-design-system-modal>
    }
    @case (Step.REASON) {
      <web-design-system-modal [headline]="'user-self-service.terminate-depot.reason.headline' | transloco" (dismiss)="close()">
        <p [innerHTML]="'user-self-service.terminate-depot.reason.body' | transloco"></p>
        <div class="input-group-material mt-3 pt-1">
          <textarea
            [value]="reason"
            (input)="reason = $any($event.target).value"
            [placeholder]="'user-self-service.terminate-depot.reason.textarea' | transloco"
          ></textarea>
        </div>
        <div class="d-flex align-items-center justify-content-between mt-4">
          <div>
            <a class="link-secondary text-uppercase cursor-pointer" (click)="next()">
              {{ 'user-self-service.terminate-depot.reason.next' | transloco }}
            </a>
          </div>
          <div class="spacer"></div>
          <web-design-system-button (click)="close()">{{
            'user-self-service.terminate-depot.reason.close' | transloco
          }}</web-design-system-button>
        </div>
      </web-design-system-modal>
    }
    @case (Step.CHECK_LIST) {
      <web-design-system-modal [headline]="'user-self-service.terminate-depot.check-list.headline' | transloco" (dismiss)="close()">
        @if (terminateDepotFacade.checklist$ | async; as checklist) {
          <div class="d-flex align-items-center justify-content-between">
            <div>
              {{ 'user-self-service.terminate-depot.check-list.depotEmpty.label' | transloco }}
              @if (!checklist.depotEmpty) {
                <br />
                <a [routerLink]="commonRoutes.postlogin.member_home" class="link-secondary">{{
                  'user-self-service.terminate-depot.check-list.depotEmpty.link' | transloco
                }}</a>
              }
            </div>
            <ng-container *ngTemplateOutlet="checkOrCross; context: { flag: checklist.depotEmpty }" />
          </div>
          <hr />
          <div class="d-flex align-items-center justify-content-between">
            <div>
              {{ 'user-self-service.terminate-depot.check-list.savingsplansEmpty.label' | transloco }}
              @if (!checklist.savingsplansEmpty) {
                <br />
                <a [routerLink]="commonRoutes.postlogin.savings_plans" class="link-secondary">{{
                  'user-self-service.terminate-depot.check-list.savingsplansEmpty.link' | transloco
                }}</a>
              }
            </div>
            <ng-container *ngTemplateOutlet="checkOrCross; context: { flag: checklist.savingsplansEmpty }" />
          </div>
          <hr />
          <div class="d-flex align-items-center justify-content-between">
            <div>
              {{ 'user-self-service.terminate-depot.check-list.walletEmpty.label' | transloco }}
              @if (!checklist.walletEmpty) {
                <br />
                <a [routerLink]="commonRoutes.postlogin.member_home" class="link-secondary">{{
                  'user-self-service.terminate-depot.check-list.walletEmpty.link' | transloco
                }}</a>
              }
            </div>
            <ng-container *ngTemplateOutlet="checkOrCross; context: { flag: checklist.walletEmpty }" />
          </div>
          <hr />
          <div class="d-flex align-items-center justify-content-between">
            <div>
              {{ 'user-self-service.terminate-depot.check-list.accountEmpty.label' | transloco }}
              @if (!checklist.accountEmpty) {
                <br />
                <a [routerLink]="commonRoutes.postlogin.accountoverview" class="link-secondary">{{
                  'user-self-service.terminate-depot.check-list.accountEmpty.link' | transloco
                }}</a>
              }
            </div>
            <ng-container *ngTemplateOutlet="checkOrCross; context: { flag: checklist.accountEmpty }" />
          </div>
          <hr />
          <div class="d-flex align-items-center justify-content-between">
            <div>
              {{ 'user-self-service.terminate-depot.check-list.ordersEmpty.label' | transloco }}
              @if (!checklist.ordersEmpty) {
                <br />
                <a [routerLink]="commonRoutes.postlogin.member_home" class="link-secondary">{{
                  'user-self-service.terminate-depot.check-list.ordersEmpty.link' | transloco
                }}</a>
              }
            </div>
            <ng-container *ngTemplateOutlet="checkOrCross; context: { flag: checklist.ordersEmpty }" />
          </div>
          <hr />
          <div class="d-flex align-items-center justify-content-between">
            <div>
              {{ 'user-self-service.terminate-depot.check-list.portfolioTransfersEmpty.label' | transloco }}
              @if (!checklist.portfolioTransfersEmpty) {
                <br />
                <span class="zero-text p-small-med">{{
                  'user-self-service.terminate-depot.check-list.portfolioTransfersEmpty.link' | transloco
                }}</span>
              }
            </div>
            <ng-container *ngTemplateOutlet="checkOrCross; context: { flag: checklist.portfolioTransfersEmpty }" />
          </div>
          <hr />
          <div class="d-flex align-items-center justify-content-between">
            <div>
              {{ 'user-self-service.terminate-depot.check-list.sentDirectDebitEmpty.label' | transloco }}
              @if (!checklist.sentDirectDebitEmpty) {
                <br />
                <span class="zero-text p-small-med">{{
                  'user-self-service.terminate-depot.check-list.sentDirectDebitEmpty.link' | transloco
                }}</span>
              }
            </div>
            <ng-container *ngTemplateOutlet="checkOrCross; context: { flag: checklist.sentDirectDebitEmpty }" />
          </div>
          <hr />
        }
        <div class="d-flex align-items-center justify-content-between mt-4">
          <div>
            @if (terminateDepotFacade.isReady$ | async) {
              <a class="link-secondary text-uppercase cursor-pointer" (click)="next()">
                {{ 'user-self-service.terminate-depot.check-list.next' | transloco }}
              </a>
            } @else {
              <a class="link-secondary disabled text-uppercase">
                {{ 'user-self-service.terminate-depot.check-list.next' | transloco }}
              </a>
            }
            <ng-template #disabled>
              <a class="link-secondary disabled text-uppercase">
                {{ 'user-self-service.terminate-depot.check-list.next' | transloco }}
              </a>
            </ng-template>
          </div>
          <div class="spacer"></div>
          <web-design-system-button (click)="close()">
            {{ 'user-self-service.terminate-depot.check-list.close' | transloco }}
          </web-design-system-button>
        </div>
      </web-design-system-modal>
    }
    @case (Step.AUTHORIZATION) {
      <div [zeroLoadingIndicator]="terminateDepotFacade.loading$ | async">
        <web-design-system-modal [headline]="'user-self-service.terminate-depot.authorization.headline' | transloco" (dismiss)="close()">
          <p [innerHTML]="'user-self-service.terminate-depot.authorization.body' | transloco"></p>
          <div class="d-flex align-items-center justify-content-between alert mb-4">
            <div class="ml-3 mr-3">
              <svg class="icon icon-18"><use xlink:href="/assets/img/svgs/svgset.svg#alert-danger" /></svg>
            </div>
            <div class="font-bold">
              {{ 'user-self-service.terminate-depot.authorization.alert' | transloco }}
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-between mt-4">
            <div>
              <a class="link-secondary text-uppercase cursor-pointer" (click)="terminate()">
                {{ 'user-self-service.terminate-depot.authorization.next' | transloco }}
              </a>
            </div>
            <div class="spacer"></div>
            <web-design-system-button (click)="close()">
              {{ 'user-self-service.terminate-depot.authorization.close' | transloco }}
            </web-design-system-button>
          </div>
          @if (terminateDepotFacade.dataToAuthorize$ | async; as dataToAuthorize) {
            <div class="row mt-4">
              <div class="col-12">
                <web-components-transaction-auth
                  [payload]="dataToAuthorize"
                  (transactionResult)="terminateDepotFacade.handleAuthenticationResult($event)"
                />
              </div>
            </div>
          }
          @if (terminateDepotFacade.hasError$ | async) {
            <div class="row mt-4">
              <div
                class="col-12 text-color-error text-center"
                [innerHTML]="'user-self-service.terminate-depot.authorization.error' | transloco"
              ></div>
            </div>
          }
        </web-design-system-modal>
      </div>
    }
    @case (Step.SUCCESS) {
      <web-design-system-modal [headline]="'user-self-service.terminate-depot.success.headline' | transloco" (dismiss)="close()">
        {{ 'user-self-service.terminate-depot.success.body' | transloco }}
        <div class="d-flex align-items-center justify-content-between mt-4">
          <div>
            <a [routerLink]="commonRoutes.postlogin.tickets" class="link-secondary text-uppercase cursor-pointer">
              {{ 'user-self-service.terminate-depot.success.next' | transloco }}
            </a>
          </div>
          <web-design-system-button (click)="handleSuccess()">
            {{ 'user-self-service.terminate-depot.success.close' | transloco }}
          </web-design-system-button>
        </div>
      </web-design-system-modal>
    }
  }
</ng-template>

<ng-template #checkOrCross let-flag="flag">
  <div>
    <span class="icon icon-18" [ngClass]="{ haken: flag, cross: !flag }"></span>
  </div>
</ng-template>
